class Chromosome {
    constructor(name, order, bpLength) {
        this.name = name
        this.order = order
        this.bpLength = bpLength
    }
}

export default Chromosome